import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="schedule-preview"
export default class extends Controller {
  static targets = ["preview", "frequency", "enabled"];
  static values = { currentTime: String };

  connect() {
    this.updatePreview();
  }

  updatePreview() {
    // Handle both select dropdowns and radio buttons
    let frequency;
    const firstTarget = this.frequencyTargets[0];

    if (firstTarget && firstTarget.tagName === "SELECT") {
      // Select dropdown
      frequency = firstTarget.value;
    } else if (this.frequencyTargets.length > 0) {
      // Radio buttons - find the checked one
      const checkedRadio = this.frequencyTargets.find((radio) => radio.checked);
      frequency = checkedRadio ? checkedRadio.value : null;
    } else {
      frequency = null;
    }

    const enabled = this.enabledTarget.checked;

    if (!enabled || !frequency) {
      this.previewTarget.classList.add("hidden");
      return;
    }

    const nextDate = this.calculateNextAnalysisAt(frequency);
    const formattedDate = this.formatDate(nextDate);

    this.previewTarget.classList.remove("hidden");
    this.previewTarget.innerHTML = `
      <div class="text-sm">
        <span class="font-medium">Next scheduled analysis:</span>
        <span class="text-base-content/70">${formattedDate}</span>
      </div>
    `;
  }

  calculateNextAnalysisAt(frequency) {
    const now = new Date();
    let nextDate = new Date(now);

    switch (frequency) {
      case "daily":
        // Schedule for next day at 3 AM
        nextDate.setDate(now.getDate() + 1);
        nextDate.setHours(3, 0, 0, 0);
        break;
      case "weekly":
        // Schedule for next week at 3 AM
        nextDate.setDate(now.getDate() + 7);
        nextDate.setHours(3, 0, 0, 0);
        break;
      case "monthly":
        // Schedule for next month at 3 AM
        nextDate.setMonth(now.getMonth() + 1);
        nextDate.setDate(1);
        nextDate.setHours(3, 0, 0, 0);
        break;
      default:
        // Default to monthly
        nextDate.setMonth(now.getMonth() + 1);
        nextDate.setDate(1);
        nextDate.setHours(3, 0, 0, 0);
    }

    return nextDate;
  }

  formatDate(date) {
    const months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];

    const month = months[date.getMonth()];
    const day = date.getDate();
    const year = date.getFullYear();

    let hours = date.getHours();
    const minutes = date.getMinutes();
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    const minutesStr = minutes < 10 ? `0${minutes}` : minutes;

    return `${month} ${day}, ${year} at ${hours}:${minutesStr} ${ampm}`;
  }

  frequencyChanged() {
    this.updatePreview();
  }

  enabledChanged() {
    this.updatePreview();
  }
}
